import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Navbar = ({ user, onLogout, onChangePassword }) => {
    // Get user initials for avatar
    const getInitials = (name) => {
        if (!name) return "?";
        const parts = name.trim().split(/\s+/);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-premium">
            <div className="container-fluid">
                <a className="navbar-brand-premium" href="#home">
                    <div className="navbar-brand-logo">DS</div>
                    Admin Domicilios SURA
                </a>
                <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center gap-2 me-2">
                        <div className="user-avatar">
                            {getInitials(user.name || user.email)}
                        </div>
                        <div className="user-info-text d-none d-md-block">
                            <div className="user-name">{user.name || user.email}</div>
                            {user.role && <div className="user-role">{user.role}</div>}
                        </div>
                    </div>
                    <button
                        className="btn btn-glass btn-sm"
                        onClick={onChangePassword}
                    >
                        🔒 <span className="d-none d-md-inline">Cambiar Contraseña</span>
                    </button>
                    <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={onLogout}
                    >
                        Salir
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
